import { StoreType } from '@/redux/store';

export const getUF = ({ uf }: StoreType) => uf;

export const getUFValue = ({ uf }: StoreType) => uf.value;

export const getUFDate = ({ uf }: StoreType) => uf.date;
